import React from 'react';
import { Button, FormControl, Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import { updateUserProfile } from 'reducers/auth/auth.actions';
import { LOGIN, PROFILE } from 'constants/routes';
import * as Yup from 'yup';
import { selectAuthUser } from 'reducers/auth/auth.selectors';
import Loader from 'components/Loader';
import { Link, useHistory } from 'react-router-dom';
import { getLaravelValidationErrors } from 'helpers';
import LoginTermsAndConditions from 'components/generic-components/LoginTermsAndConditions';
import LanguageSwitcher from 'components/generic-components/LanguageSwitcher';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import LoginRegisterHeader from 'components/generic-components/LoginRegisterHeader';

const NewPasswordScreen = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const user = useSelector(selectAuthUser);
    const history = useHistory();

    const { values, status, handleSubmit, errors, touched, handleChange, isSubmitting } = useFormik({
        initialValues: {
            password: '',
            password_confirmation: '',
        },
        validationSchema: Yup.object().shape({
            password: Yup.string().trim().required(),
            password_confirmation: Yup.string()
                .trim()
                .when('password', {
                    is: password => !!password,
                    then: Yup.string().required(),
                }),
        }),
        onSubmit: (values, { setStatus, setSubmitting }) => {
            dispatch(updateUserProfile(user.id, { ...values }))
                .then(resp => {
                    history.push(PROFILE);
                })
                .catch(errors => {
                    console.log('Form errors', errors);
                    setStatus({
                        errors: getLaravelValidationErrors(errors),
                    });
                    setSubmitting(false);
                });
        },
    });

    return (
        <div
            className="d-flex flex-column flex-fill pt-4 pb-5 background_dark register-container">

            <LoginRegisterHeader />

            <Form className="login-form mt-5" onSubmit={handleSubmit}>
                <Loader isLoadin={isSubmitting} height={405} size={60}>
                    <div className="d-flex flex-column mx-auto w-100 align-items-center ">
                        <Form.Group className="w-100 mt-3">
                            <InputGroup size="lg">
                                <FormControl
                                    className=" border-bottom border-bottom-dark input-login font-size-12"
                                    type="password"
                                    name="password"
                                    autoComplete="off"
                                    value={values.password}
                                    onChange={handleChange}
                                    placeholder={t('New password')}
                                    isInvalid={touched.password && errors.password}
                                />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {!!errors.password && errors.password}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="w-100  mt-3">
                            <InputGroup size="lg">
                                <FormControl
                                    type="password"
                                    className=" border-bottom border-bottom-dark input-login font-size-12"
                                    name="password_confirmation"
                                    autoComplete="off"
                                    value={values.password_confirmation}
                                    onChange={handleChange}
                                    placeholder={t('Repeat new password')}
                                    isInvalid={touched.password_confirmation && errors.password_confirmation}
                                />
                                <Form.Control.Feedback type="invalid" tooltip>
                                    {!!errors.password_confirmation && errors.password_confirmation}
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        {status &&
                            status.errors &&
                            <p className="text-danger my-2 w-100" style={{ fontSize: '12.6px' }}>
                                {status.errors[0]}
                            </p>
                        }

                        <ButtonComponent
                            btnText={'Continue'}
                            transparent={false}
                            customClass={'mt-5 mb-3 btn-gradient custom-sign-in-btn'}
                        />

                        <p className={'text-lightPurple sign-up-here'}>
                            {t('Already have an account')}
                        </p>

                        <p className={'log-in-here text-white mt-2'}>
                            <Link to={LOGIN} className="font-weight-bold">
                                {t('Sign in')}
                            </Link>
                        </p>
                    </div>
                </Loader>
            </Form>

            <LoginTermsAndConditions />
            <LanguageSwitcher />
        </div >
    );
};

export default NewPasswordScreen;
